import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { TransactionType } from '../../../../store/web3/unbind.side-effects'

export interface TxPendingConfirmModalProps {
  txType?: TransactionType
}

export const TxPendingConfirmModal: React.FC<TxPendingConfirmModalProps> = (
  props,
) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    ref.current?.focus()
    ref.current?.scrollIntoView()
  })
  const { t } = useTranslation()

  let txText = 'unknownTxType'
  switch (props.txType) {
    case TransactionType.APPROVE_AZUKI:
      txText = 'approveAzuki'
      break
    case TransactionType.APPROVE_MOMIJI:
      txText = 'approveMomiji'
      break
    case TransactionType.UNBIND:
      txText = 'unbind'
      break
  }
  txText = t(txText)

  return (
    <StyledTxBackground ref={ref}>
      <TxNft>
        <TxNftBackground>
          <TxNftBorder>
            <StyledH1>{t('Waiting for Transaction Confirmation')}</StyledH1>
            <Spinner />
            <Helper>{t('Confirm this transaction in your wallet')}</Helper>
            <p>{txText}</p>
          </TxNftBorder>
        </TxNftBackground>
      </TxNft>
    </StyledTxBackground>
  )
}

const Helper = styled.h3`
  color: white;
  font-size: 1.275rem;

  text-align: center;
`

const StyledH1 = styled.h1`
  font-weight: 500;
  margin-top: 0;
  text-align: center;
`

const Spinner = styled.div`
  display: inline-block;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #c173ff;
  animation: 1s spin ease-in-out infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  @media (min-width: 200px) {
    width: 5rem;
    height: 5rem;
  }

  @media (min-width: 1200px) {
    width: 10rem;
    height: 10rem;
    margin-bottom: 3rem;
  }
`

const TxNftBackground = styled.div`
  background: black;
  @media (min-width: 200px) {
    padding: 1rem;
  }
  @media (min-width: 1200px) {
    padding: 2rem;
  }
`

const TxNftBorder = styled.div`
  border: 2px solid #c173ff;
  position: relative;

  display: grid;
  grid-template-rows: min-content min-content min-content min-content;
  row-gap: 2rem;
  justify-items: center;

  position: relative;

  @media (min-width: 200px) {
    padding: 1rem;
  }
  @media (min-width: 1200px) {
    width: 700px;
    padding: 4rem;
  }
`

const TxNft = styled.div`
  width: 100%;

  @media (min-width: 200px) {
    height: 100%;
  }
  @media (min-width: 1200px) {
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
  }
`

const StyledTxBackground = styled.section`
  z-index: 1001;
  background: rgba(0, 0, 0, 0.795);
  display: flex;
  justify-content: center;

  @media (min-width: 200px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  @media (min-width: 750px) {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }
`
